import classnames from 'classnames';
import React, { ReactNode } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Dispatch } from 'redux';
import { closeModal } from '@mm/state/modules/modalsState/actions';
import { StoreState } from '@mm/state/store-interfaces';
import './BasicModalTemplate.pcss';
import { CloseOutlined } from '@ant-design/icons';

type OuterProps = {
  className?: string;
  iconClass?: string;
  topClassName?: string;
  children: ReactNode | Element[];
  closeOverride?: () => any;
  withMonkeyBackground?: boolean;
  hideCloseButton?: boolean;
};

type InnerProps = ReturnType<typeof mapDispatchToProps>;

type Props = OuterProps & InnerProps;

export const BASIC_MODAL_TEMPLATE_ID = 'basic-modal-template';

const BasicModalTemplate = (props: Props) => {
  const {
    className,
    children,
    closeOverride,
    closeModal,
    withMonkeyBackground,
    topClassName,
    hideCloseButton,
    iconClass,
  } = props;
  const classList = classnames('basic-modal-template__modal-area', className);
  const topClassList = classnames('basic-modal-template', topClassName, {
    'basic-modal-template--monkey-background': withMonkeyBackground,
  });
  const closeFunction = closeOverride || closeModal;

  return (
    <div className={topClassList} id={BASIC_MODAL_TEMPLATE_ID}>
      <div className={classList}>{children}</div>
      <div className="basic-modal-template__background" />
      {withMonkeyBackground && (
        <div className="basic-modal-template__monkey-background" />
      )}

      {!hideCloseButton && (
        <div
          className="basic-modal-template__close-icon"
          onClick={closeFunction}
        >
          <CloseOutlined className={iconClass} />
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  closeModal: () => dispatch(closeModal()),
});

const enhance = compose<InnerProps, OuterProps>(
  connect(null, mapDispatchToProps),
);

export default enhance(BasicModalTemplate);
